export default "__VITE_ASSET__e1948de7__"